module.exports = new __parcel__URL__("delivery-dark.f32a9f49.svg").toString();